import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import {
  AGENDA_SOLUTIONS_APPROVE,
  AGENDA_SOLUTIONS_SUGGEST,
  BOARDS_COUNT,
  LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC,
  LOGIN_NOT_AGENDA_SOLUTIONS_LOG,
} from 'manager/http-constants';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { ChatComponent } from '../common/chat/chat.component';
import { DATE_FORMAT } from 'src/app/shared/constant/constant';
import { PlatformComponent } from '../platform.component';
import { ApprovalDialogComponent } from '../common/approval-dialog/approval-dialog.component';
import { DiffTableComponent } from '../common/diff-table/diff-table.component';
import { AGENDA_SOLUTION_TEMPLATE } from 'manager/template-constant';
import { ConfirmQuotationDialogComponent } from 'src/app/pages/platform/common/confirm-quotation-dialog/confirm-quotation-dialog.component';
import { FollowDialogComponent } from 'src/app/pages/platform/common/follow-dialog/follow-dialog.component';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-c301',
  templateUrl: './c301.component.html',
  styleUrls: ['./c301.component.scss', '../platform.component.scss'],
})

/**
 * 課題・ソリューション詳細
 */
export class C301Component extends PlatformComponent {

  /** common part follow/unfollow dialog */
  @ViewChild(FollowDialogComponent)
  followDialogComponent: FollowDialogComponent;

  /** common part citing dialog dialog */
  @ViewChild(ConfirmQuotationDialogComponent)
  confirmQuotationDialogComponent: ConfirmQuotationDialogComponent;

  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;

  /** 共通部品_チャット */
  @ViewChild(ChatComponent)
  chatComponent: ChatComponent;

  /** 共通部品_差分比較 */
  @ViewChild(DiffTableComponent)
  diffTableComponent: DiffTableComponent;

  // 課題ID
  agendaId: string = this.route.snapshot.params.agenda_id;

  // 課題・ソリューション詳細格納先
  detailTask: any;

  // マッチング依頼一覧格納先
  matchingList: any;

  // 質問掲示板の件数格納先
  countQuestionBoard: number = 0;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private messageData: MessageData,
    private location: Location,
    private loginService: LoginService,
    private datePipe: DatePipe,
    private titleService: Title
  ) {
    super(route, commonService, dbOperationService, loadingState);
    this.titleService.setTitle('地方創生SDGs官民連携マッチングシステム｜内閣府');
  }

  ngOnInit(): void {
    this.loginService.getAuth0LoginState().subscribe((response) => {
      // ログイン状態をセット

      // ログイン状態を判定
      if (response) {
        // ログイン状態の場合

        /* ログインユーザー情報 */
        // セッションからログインユーザ情報取得
        const loginUser = JSON.parse(
          window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
        );

        // セッションにログインユーザ情報が存在するか否か
        if (loginUser) {
          // セッションにログインユーザが存在する場合

          // 課題・ソリューション結果を取得
          // 辞書値リストを取得
          this.getSpecCodeList(901, 2021, 2026);

          // 課題・ソリューション詳細を取得
          this.getDetailTask();

          // マッチング依頼一覧を取得
          this.getMatchingList();

          // 質問掲示板の件数を取得
          this.getCountQuestionBoard();
          return;
        } else {
          // セッションにログインユーザが存在しない場合(初回表示時)

          // ログインユーザ情報取得処理
          this.loginService.getLoginUser().subscribe((response) => {
            // 正常なユーザの為、セッションにユーザ情報を格納
            window.sessionStorage.setItem(
              SESSION_KEY.loginUserInformation,
              JSON.stringify(response.body[0])
            );

            this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
            // 課題・ソリューション結果を取得
           // 辞書値リストを取得
          this.getSpecCodeList(901, 2021, 2026);

          // 課題・ソリューション詳細を取得
          this.getDetailTask();

          // マッチング依頼一覧を取得
          this.getMatchingList();

          // 質問掲示板の件数を取得
          this.getCountQuestionBoard();
            return;
          });
        }
      } else {
        // 未ログイン状態の場合

        // 辞書値リストを取得
        this.getSpecCodeList(901, 2021, 2026);

        // 課題・ソリューション詳細を取得
        this.getDetailTask();

        // マッチング依頼一覧を取得
        this.getMatchingList();

        // 質問掲示板の件数を取得
        this.getCountQuestionBoard();
        return;
      }
    });
  }

  /**
   * 課題・ソリューション詳細を取得
   */
  public getDetailTask(): void {
    // fpt added: sperate api for loged in/ not loged in user
    if(!this.loginUser){
        // 画面ロードフラグをON(ロード中状態)
       this.loadingState.loadStart(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

       // 課題・ソリューション詳細を取得
       this.dbOperationService
          .getNoTemplateDisplayData(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC, this.agendaId)
          .subscribe((response) => {
            // 画面ロードフラグをOFF(ロード終了)
            this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

            if (this.commonService.checkNoneResponse(response)) {
              // 警告メッセージ
              this.messageData.toastMessage(
                new ToastMessageData({
                  severity: TOAST.WARN,
                  summary: this.commonService.msg(MESSAGE_CODE.E00003),
                  detail: this.commonService.msg(MESSAGE_CODE.E00026),
                })
              );

              // 前画面へ戻る
              this.location.back();
            } else {
              if (response.body[0].agenda_kbn.id == '1') {
                this.loginService.logout();
                return;
              }

              // 課題・ソリューション詳細を格納
              this.detailTask = response.body[0];

              // 公開掲示板をデフォルトで表示
              if (1 == this.detailTask?.board_open.id && this.decisionLoginState()) {
                this.moveChat();
              }
            }
       });
    }else{
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

      // 課題・ソリューション詳細を取得
      this.dbOperationService
        .getNoTemplateDisplayData(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC, this.agendaId)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

          if (this.commonService.checkNoneResponse(response)) {
            // 警告メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );

            // 前画面へ戻る
            this.location.back();
          } else {
            // 課題・ソリューション詳細を格納
            this.detailTask = response.body[0];

            if (this.detailTask.agenda_kbn.id == '1') {
              this.titleService.setTitle(`${this.detailTask?.title} (${this.detailTask?.organization_name}) | 官⺠地域課題`);
            } else {
              this.titleService.setTitle(`${this.detailTask?.title} (${this.detailTask?.organization_name}) | 官⺠ソリューション`);
            }


            // 公開掲示板をデフォルトで表示
            if (1 == this.detailTask?.board_open.id && this.decisionLoginState()) {
              this.moveChat();
            }
          }
        });
    }
  }

  /**
   * マッチング依頼一覧を取得
   */
  private getMatchingList(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(AGENDA_SOLUTIONS_SUGGEST);

    //  マッチング依頼一覧を取得
    this.dbOperationService
      .getNoTemplateData(
        AGENDA_SOLUTIONS_SUGGEST,
        {
          agenda_id: this.agendaId,
        },
        true
      )
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          //  マッチング依頼一覧を格納
          this.matchingList = response.body;
        } else {
          this.matchingList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, AGENDA_SOLUTIONS_SUGGEST);
      });
  }

  /**
   * 質問掲示板の件数を取得
   */
  private getCountQuestionBoard(): void {
    // ログイン状態を判定
    if (!this.decisionLoginState()) {
      // 未ログインの場合

      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(BOARDS_COUNT);

    // 質問掲示板の件数を取得
    this.dbOperationService
      .getNoTemplateData(BOARDS_COUNT, {
        agenda_id: this.agendaId,
      })
      .subscribe((response) => {
        // 質問掲示板の件数を格納
        this.countQuestionBoard = response.body.count;

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, BOARDS_COUNT);
      });
  }

  /**
   * チャット機能表示
   */
  public moveChat(): void {
    if(this.detailTask.agenda_kbn.id == 1 && this.detailTask.past_issue == '1'){
      return;
    }
    // チャット機能表示
    this.chatComponent.initial(this.agendaId);
  }

  /**
   * マッチング提案登録(C401)へ遷移する
   */
  public moveC401(): void {
    // マッチング提案登録(C401)へ遷移
    this.router.navigate(['pages/platform/c401/new'], {
      queryParams: {
        screenId: 'c401',
        agenda_id: this.route.snapshot.params.agenda_id,
      },
    });
  }

  /**
   * 課題・ソリューション登録(C101)へ遷移する
   * @param isQuotation true if is citing issue
   */
  public moveC101(isQuotation?:boolean): void {
    //if is cting
    if(isQuotation){
      // 課題・ソリューション登録(C101)へ遷移
      this.router.navigate(['pages/platform/c101/duplicate'], {
        queryParams: {
          screenId: 'c101',
          agenda_id: this.route.snapshot.params.agenda_id,
          agenda_kbn: this.detailTask.agenda_kbn.id,
        },
      });
    // if editing
    }else{
      // 課題・ソリューション登録(C101)へ遷移
      this.router.navigate(['pages/platform/c101/edit'], {
        queryParams: {
          screenId: 'c101',
          agenda_id: this.route.snapshot.params.agenda_id,
          agenda_kbn: this.detailTask.agenda_kbn.id,
        },
      });
    }
  }

  /**
   * マッチング提案掲示板(C601)へ遷移する
   * @param suggestId 提案ID
   */
  public moveC601(suggestId: string): void {
    // マッチング提案掲示板(C601)へ遷移
    this.router.navigate(['pages/platform/c601/' + suggestId], {
      queryParams: {
        agenda_id: this.route.snapshot.params.agenda_id,
      },
    });
  }


  /**
   * 公開判定フラグ
   * @returns 0:表示なし 1:公開中 2:非公開
   */
  public releaseFlag(status: number, endDate: string, agenda_kbn_id: number): number {
    // 課題・ソリューション詳細の判定
    if (!this.detailTask) {
      // 課題・ソリューション詳細が存在しない場合

      return 0;
    }

    // 課題記載ユーザ or 事務局ユーザーか否か
    if (
      this.decisionPerspective(this.detailTask.member_id) ||
      this.decisionSecretariat()
    ) {
      // 課題記載ユーザ or 事務局ユーザーの場合

      if(agenda_kbn_id == 1 && this.detailTask.past_issue == '1'){
        if (status==2){
          return 1;
        }else{
          return 2;
        }
      }else{
        //followed up issue can have no endDate
        if(endDate){
          // 掲載終了日の判定
          if (
            this.datePipe.transform(new Date(), DATE_FORMAT.DATE) <=
            this.datePipe.transform(new Date(endDate), DATE_FORMAT.DATE)
          ) {
            // 掲載終了日より前の場合
            if (status==2){
              return 1;
            }else{
              return 2;
            }
          } else {
            // 掲載終了日より後の場合

            return 2;
          }
        }else{
          return 2;
        }
      }
    }

    return 0;
  }


  // /**
  //  * 公開判定フラグ
  //  * @returns 0:表示なし 1:公開中 2:非公開
  //  */
  // public releaseFlag(): number {
  //   // 課題・ソリューション詳細の判定
  //   if (!this.detailTask) {
  //     // 課題・ソリューション詳細が存在しない場合

  //     return 0;
  //   }

  //   // 課題記載ユーザ or 事務局ユーザーか否か
  //   if (
  //     this.decisionPerspective(this.detailTask.member_id) ||
  //     this.decisionSecretariat()
  //   ) {
  //     // 課題記載ユーザ or 事務局ユーザーの場合

  //     // 掲載終了日の判定
  //     if (
  //       this.datePipe.transform(new Date(), DATE_FORMAT.DATE) <=
  //       this.datePipe.transform(
  //         new Date(this.detailTask?.end_date),
  //         DATE_FORMAT.DATE
  //       )
  //     ) {
  //       // 掲載終了日より前の場合

  //       return 1;
  //     } else {
  //       // 掲載終了日より後の場合

  //       return 2;
  //     }
  //   }

  //   return 0;
  // }

  /**
   * 内閣府承認ダイアログ表示
   */
  public openSmallApprovalDialog(): void {
    // 内閣府承認ダイアログ表示
    this.approvalDialogComponent.openSmallApprovalDialog(
      AGENDA_SOLUTIONS_APPROVE,
      this.agendaId,
      2003,
      0,
      1
    );
  }

  /**
   * 差分ダイアログ表示
   */
   public openDiffDialog(screen_id: string): void {
     // 差分比較ダイアログ表示
     this.diffTableComponent.openDiffTable(
       screen_id,
       LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC,
       LOGIN_NOT_AGENDA_SOLUTIONS_LOG,
       this.agendaId,
       2004,
       0,
       1
     );
   }

  /**
   * 課題・ソリューション検索(C201)へ遷移する
   *
   */
  public moveC201(): void {
    //課題・ソリューション検索(C201)へ遷移する
    this.router.navigate(['pages/platform/c201']);
  }

  /**
   * 会員プロフィール(B211 or B212)へ遷移する
   * @param memberId 会員ID
   * @param classId 会員種別
   */
  public moveB211orMoveB212(memberId: string, classId: string): void {
    // 自治体 or 2号会員が否か
    if ('1' == classId || '2' == classId) {
      // 自治体 or 2号会員の場合

      // 会員プロフィール(自治体)(B211)へ遷移
      this.router.navigate(['pages/platform/b211/' + memberId]);
    } else {
      // 民間団体の場合

      // 会員プロフィール(民間団体)(B212)へ遷移
      this.router.navigate(['pages/platform/b212/' + memberId]);
    }
  }

  /**
   * Open follow dialog
   * @param agendaId agenda to follow
   * @param agendaTitle agenda title to display
   * @param member_id created member id
   */
  openConfirmFollowdialog(agendaId:string,agendaTitle:string,member_id:string){
    this.followDialogComponent.showConfirmFollowDialog(agendaId,agendaTitle,member_id);
  }

  /**
   * open unfollow dialog
   * @param agendaId agenda to unfollow
   * @param agendaTitle agenda title to unfollow
   */
  openConfirmUnFollowdialog(agendaId:string,agendaTitle:string){
    this.followDialogComponent.showConfirmUnFollowDialog(agendaId,agendaTitle);
  }

  /**
   * open confirm adding a quotation dialog
   */
  confirmQuotation(){
    if(!this.loginUser){
      return;
    }
    this.confirmQuotationDialogComponent.openDialog();
  }

  /**
   * re fetch data
   */
  reload(){
       // 課題・ソリューション詳細を取得
       this.getDetailTask();

       // マッチング依頼一覧を取得
       this.getMatchingList();

       // 質問掲示板の件数を取得
       this.getCountQuestionBoard();
  }

  /**
   * login and redirect to c401
   */
  loginToC401(){
    this.loginService.loginToPage('/redirect?agendaID='+this.agendaId+'&mode=1');
  }
}
